import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '#pplx/frontend/aether/components/Link/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export function ArtifactThreadLink({ threadUrl, isComputerTask, track, }) {
    if (!threadUrl)
        return null;
    return (_jsx(Link, { href: threadUrl, track: track, variant: "secondary", size: "small", pill: true, leadingAccessory: isComputerTask ? $icon('custom-computer') : $icon('custom-perplexity-thread'), trailingAccessory: $icon('arrow-up-right'), children: _jsx(FormattedMessage, { defaultMessage: "Open session", id: "5756abaa16", description: "Link in the artifact media lightbox to open the session or thread that produced the artifact" }) }));
}
//# sourceMappingURL=useArtifactOpenComponents.js.map